const guiColors = {
    'motion-primary': '#3C7699',
    'motion-primary-transparent': '#3C7699e6',
    'motion-tertiary': '#305e7a',

    'looks-secondary': '#a6e699',
    'looks-transparent': '#75C1C459',
    'looks-light-transparent': '#75C1C426',
    'looks-secondary-dark': '#a6e699',

    'extensions-primary': 'hsla(203, 44%, 42%, 1)',
    'extensions-tertiary': 'hsla(203, 44%, 25%, 1)',
    'extensions-transparent': 'hsla(203, 44%, 42%, 0.35)',
    'extensions-light': '#a6e699',

    'drop-highlight': '#9ce88d'
};

const blockColors = {
    checkboxActiveBackground: '#3C7699',
    checkboxActiveBorder: '#305e7a'
};

export {
    guiColors,
    blockColors
};
